export const ACCENT_COLOR = '#546C8E';
